/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsExternalEhrPatient
 */
export interface MatrixCarePatientDetailsExternalEhrPatient {
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsExternalEhrPatient
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsExternalEhrPatient
     */
    type?: MatrixCarePatientDetailsExternalEhrPatientTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsExternalEhrPatient
     */
    details_push_date?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsExternalEhrPatient
     */
    details_extraction_date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCarePatientDetailsExternalEhrPatient
     */
    is_extracting_details?: boolean;
    /**
     * 
     * @type {Array<FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead>}
     * @memberof MatrixCarePatientDetailsExternalEhrPatient
     */
    leads?: Array<FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead>;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCarePatientDetailsExternalEhrPatient
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCarePatientDetailsExternalEhrPatient
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCarePatientDetailsExternalEhrPatient
     */
    is_generated_document_upload_in_progress?: boolean;
}


/**
 * @export
 */
export const MatrixCarePatientDetailsExternalEhrPatientTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB'
} as const;
export type MatrixCarePatientDetailsExternalEhrPatientTypeEnum = typeof MatrixCarePatientDetailsExternalEhrPatientTypeEnum[keyof typeof MatrixCarePatientDetailsExternalEhrPatientTypeEnum];


/**
 * Check if a given object implements the MatrixCarePatientDetailsExternalEhrPatient interface.
 */
export function instanceOfMatrixCarePatientDetailsExternalEhrPatient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MatrixCarePatientDetailsExternalEhrPatientFromJSON(json: any): MatrixCarePatientDetailsExternalEhrPatient {
    return MatrixCarePatientDetailsExternalEhrPatientFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsExternalEhrPatient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'details_push_date': !exists(json, 'details_push_date') ? undefined : json['details_push_date'],
        'details_extraction_date': !exists(json, 'details_extraction_date') ? undefined : json['details_extraction_date'],
        'is_extracting_details': !exists(json, 'is_extracting_details') ? undefined : json['is_extracting_details'],
        'leads': !exists(json, 'leads') ? undefined : ((json['leads'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON)),
        'is_screener_document_upload_in_progress': !exists(json, 'is_screener_document_upload_in_progress') ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': !exists(json, 'is_additional_document_upload_in_progress') ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': !exists(json, 'is_generated_document_upload_in_progress') ? undefined : json['is_generated_document_upload_in_progress'],
    };
}

export function MatrixCarePatientDetailsExternalEhrPatientToJSON(value?: MatrixCarePatientDetailsExternalEhrPatient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'type': value.type,
        'details_push_date': value.details_push_date,
        'details_extraction_date': value.details_extraction_date,
        'is_extracting_details': value.is_extracting_details,
        'leads': value.leads === undefined ? undefined : ((value.leads as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON)),
        'is_screener_document_upload_in_progress': value.is_screener_document_upload_in_progress,
        'is_additional_document_upload_in_progress': value.is_additional_document_upload_in_progress,
        'is_generated_document_upload_in_progress': value.is_generated_document_upload_in_progress,
    };
}

